import MUIListItemIcon from '@material-ui/core/ListItemIcon';

const ListItemIcon = ({ children, ...otherProps }) => (
  <MUIListItemIcon {...otherProps}>{children}</MUIListItemIcon>
)

export default ListItemIcon